module.exports = __webpack_public_path__ + "static/media/hangman11.1c0e7018.svg";